import React, { Component } from 'react'
import { createPortal } from 'react-dom'

const rootCustomPopupWrapper = document.querySelector('#custom-content-popup')
const rootSlidebarRight = document.querySelector('#site-slidebar-right')
const rootSlidebarRightSecond = document.querySelector('#site-slidebar-right-second')
const rootSlidebarLeft = document.querySelector('#site-slidebar-left')
const rootSite = document.querySelector('html')


export class SiteSlidebarRight extends Component {
    constructor(props) {
        super(props)

        this.elWrapper = rootSite
        this.el = document.createElement('div')
        this.el.classList.add("slidebar-inner", "slidebar-right-inner")
    }

    componentDidMount() {
        const { isNavigation, headerAppearance } = this.props
        const className = isNavigation ? 'slidebar-right-nav-open' : 'slidebar-right-open'
        const filledWithColorClass = headerAppearance === 'filled_with_color' ? 'colored-header' : headerAppearance === 'partly_filled_with_color' ? 'partly-colored-header' : ''
        
        rootSlidebarRight.appendChild(this.el)
        this.elWrapper.classList.add(className)
        filledWithColorClass && rootSlidebarRight.classList.add(filledWithColorClass)
    }
    
    componentWillUnmount() {
        const { isNavigation, removeHtmlClass, headerAppearance } = this.props
        const className = isNavigation ? 'slidebar-right-nav-open' : 'slidebar-right-open'
        const filledWithColorClass = headerAppearance === 'filled_with_color' ? 'colored-header' : headerAppearance === 'partly_filled_with_color' ? 'partly-colored-header' : ''

        removeHtmlClass ? removeHtmlClass('navigation-is-active') : ''

        rootSlidebarRight.removeChild(this.el)
        this.elWrapper.classList.remove(className)
        filledWithColorClass && rootSlidebarRight.classList.remove(filledWithColorClass)
    }

    render() {
        return createPortal(this.props.children, this.el)
    }
}

export class SiteSlidebarRightSecond extends Component {
    constructor(props) {
        super(props)

        this.elWrapper = rootSite
        this.el = document.createElement('div')
        this.el.classList.add("slidebar-inner", "slidebar-right-second-inner")
    }

    componentDidMount() {
        rootSlidebarRightSecond.appendChild(this.el)
        this.elWrapper.classList.add('slidebar-right-second-open')
    }

    componentWillUnmount() {
        rootSlidebarRightSecond.removeChild(this.el)
        this.elWrapper.classList.remove('slidebar-right-second-open')
    }

    render() {
        return createPortal(this.props.children, this.el)
    }
}


export class SiteSlidebarLeft extends Component {
    constructor(props) {
        super(props)

        this.elWrapper = rootSite
        this.el = document.createElement('div')
        this.el.classList.add("slidebar-inner", "slidebar-left-inner",)
    }

    componentDidMount() {
        rootSlidebarLeft.appendChild(this.el)
        rootSlidebarLeft.classList.add(this.props.informationStyling)
        this.elWrapper.classList.add('slidebar-left-open')
    }
    
    componentWillUnmount() {
        rootSlidebarLeft.removeChild(this.el)
        rootSlidebarLeft.classList.remove(this.props.informationStyling)
        this.elWrapper.classList.remove('slidebar-left-open')
    }

    render() {
        return createPortal(this.props.children, this.el)
    }
}

export class CustomPopupWrapper extends Component {
    constructor(props) {
        super(props)

        this.elWrapper = rootSite
        this.el = document.createElement('div')
    }

    componentDidMount() {
        const popupEl = document.getElementById('custom-popup-wrapper-inner')

        if(!popupEl) {
            rootCustomPopupWrapper.appendChild(this.el)
            this.el.setAttribute("id", "custom-popup-wrapper-inner")
        }
    }

    componentWillUnmount() {
        const popupEl = document.getElementById('custom-popup-wrapper-inner')

        if(popupEl) {
            rootCustomPopupWrapper.removeChild(popupEl)
        }
    }


    render() {
        return createPortal(this.props.children, this.el)
    }
}